import { render, staticRenderFns } from "./SpecialistSettings.vue?vue&type=template&id=b4364a8a"
import script from "./SpecialistSettings.vue?vue&type=script&lang=js"
export * from "./SpecialistSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports